import type { FC, ReactNode } from 'react';
import { Children } from 'react';
import { Card, CardRow, Separator } from '@george-labs.com/design-system';

import { AmountHighlight } from './highlight/AmountHighlight';
import { DateHighlight } from './highlight/DateHighlight';
import { TextHighlight } from './highlight/TextHighlight';
import { PercentageHighlight } from './highlight/PercentageHighlight';

interface Props {
    'data-cy'?: string;
    className?: string;
    children: ReactNode;
}

type ExportedHighlights = {
    AmountHighlight: typeof AmountHighlight;
    DateHighlight: typeof DateHighlight;
    PercentageHighlight: typeof PercentageHighlight;
    TextHighlight: typeof TextHighlight;
};

export const Highlights: FC<Props> & ExportedHighlights = ({
    'data-cy': dataCy,
    className,
    children,
}) => (
    <Card data-cy={dataCy} className={className} nested={false}>
        <CardRow>
            {Children.map(children, (child, index) => {
                if (!child || index === 0) {
                    return child;
                }

                return (
                    <>
                        <Separator />
                        {child}
                    </>
                );
            })}
        </CardRow>
    </Card>
);

Highlights.AmountHighlight = AmountHighlight;
Highlights.DateHighlight = DateHighlight;
Highlights.PercentageHighlight = PercentageHighlight;
Highlights.TextHighlight = TextHighlight;
